import { useState, useEffect } from 'react';
import { CgPushChevronLeft } from 'react-icons/cg';
import { LuFileSpreadsheet } from 'react-icons/lu';
import { FaRegChartBar } from "react-icons/fa";
import { LuTrendingUp } from "react-icons/lu";
import { BsGear } from "react-icons/bs";
import { LuClipboardCheck } from "react-icons/lu";
import { Link, useLocation } from 'react-router-dom';
import Accordion from '../atoms/Accordion';
import ActiveLink from '../atoms/ActiveLink';
import Pages from "../../definitions/Pages";

type SideBarItems = {
  [key: string]: {
    name: string;
    items: {
      name: string;
      path: string;
    }[];
    icon?: React.ReactNode;
  };
};

const SideBar: React.FC = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [showScrollbar, setShowScrollbar] = useState(false);

  const routes = {
    Paineis: {
      name: 'Painéis',
      items: [
        { name: Pages.Gestao.title, path: `/${Pages.Gestao.path}` },
        { name: Pages.Triagem.title, path: `/${Pages.Triagem.path}` }
      ],
      icon: <FaRegChartBar className="flex-none" />
    },
    Otimizacao: {
      name: 'Otimização',
      items: [
        { name: Pages.HistoricalOptimization.sidebarTitle, path: `/${Pages.HistoricalOptimization.path}` },
        { name: Pages.TriangularOptimization.sidebarTitle, path: `/${Pages.TriangularOptimization.path}` }
      ],
      icon: <LuTrendingUp className="flex-none" />
    },
    Analise: {
      name: 'Análise',
      items: [
        { name: Pages.Analise.title, path: `/${Pages.Analise.path}` }
      ],
      icon: <LuClipboardCheck className="flex-none" />
    },
    Relatorios: {
      name: 'Documentos',
      items: [
        { name: Pages.Reports.title, path: `/${Pages.Reports.path}` },
        { name: Pages.Uploads.title, path: `/${Pages.Uploads.path}` },
      ],
      icon: <LuFileSpreadsheet className="flex-none" />
    },
    Admin: {
      name: 'Admin',
      items: [
        { name: Pages.Configuracao.title, path: `/${Pages.Configuracao.path}` }
      ],
      icon: <BsGear className="flex-none" />
    }
  };

  const handleChangeSideBar = () => {
    setIsOpen(old => !old);
  };

  const [items] = useState<SideBarItems>(routes);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowScrollbar(isOpen);
    }, 200);
    return () => clearTimeout(timer);
  }, [isOpen]);

  return (
    <aside
      className={`bg-white flex flex-col px-3 pt-8 pb-2 h-screen duration-500 transition-all relative ${
        isOpen ? 'w-[300px]' : 'w-16'
      }`}
    >
      <div className="flex mb-[calc(2rem+15px)] flex-shrink-0">
        <Link 
          to="/home" 
          className="h-[38px] w-[38px] cursor-pointer"
        >
          <img
            src="/logo.png"
            alt="Logo Origem"
            className={``}
          />
        </Link>
      </div>

      <div 
        className={`flex flex-col gap-2 flex-1 min-h-0 scrollbar-transition ${
          isOpen 
            ? `overflow-y-auto ${showScrollbar ? 'scrollbar-smooth' : 'scrollbar-hidden'}`
            : 'overflow-hidden scrollbar-hidden'
        }`}
      >
        {Object.keys(items).map(it => (
          <Accordion
            key={it}
            title={items[it].name}
            icon={items[it].icon}
            buttonClassName={`${
              items[it].items.map(sub => sub.path).includes(location.pathname)
                ? 'bg-btn-light-2'
                : ''
            }`}
            forceClose={!isOpen}
            onClick={() => {
              setIsOpen(true);
            }}
          >
            {items[it].items.length > 0 && (
              <div className="flex flex-col gap-1 pt-2 pl-0">
                {items[it].items.map(subItem => (
                  <ActiveLink
                    className="flex-none text-sm whitespace-normal pl-9"
                    key={subItem.name}
                    to={subItem.path}
                  >
                    {subItem.name}
                  </ActiveLink>
                ))}
              </div>
            )}
          </Accordion>
        ))}
      </div>

      <div className="flex items-center justify-between min-h-[60px] flex-shrink-0 mt-2">
        <button
          className=" px-3 py-2 flex hover:bg-[#f5f5f5] bg-transparent border-none rounded text-primary items-center gap-2"
          onClick={handleChangeSideBar}
        >
          <CgPushChevronLeft
            className={`transition-all duration-200 ${!isOpen && 'rotate-180'}`}
          />
        </button>

        {isOpen && (
          <img
            src="/origem.png"
            alt="Logo Origem"
            className="w-[103px] resize-none max-w-none"
          />
        )}
      </div>
    </aside>
  );
};

export default SideBar;
